import { useEffect, useRef, useState } from 'react';
import { useGateValue } from '@statsig/react-bindings';
import Button from '../../components/Button';
import SurveyBanner from '../../components/SurveyBanner';
import { useNavigate } from 'react-router-dom';
import { useLayout } from '../../context/LayoutContext';
import config from '../../data/config';
import { getWithExpiry } from '../../utils/sessionStorage';
import { pushScreenerStage } from '../../utils/analytics';
const Confirmation = () => {
  const navigate = useNavigate();
  const { setFooterContent } = useLayout();

  // VI-710: the jobseeker survey banner is gated by the Statsig feature gate
  // `vi_jobseeker_survey_banner`. It ships OFF and is toggled on/off from the
  // Statsig console (e.g. switched off once the survey hits its response cap) so
  // no code change is needed. VITE_FORCE_SURVEY_BANNER is a local-dev escape
  // hatch (no Statsig client key in dev → gate is always false), mirroring the
  // VITE_FORCE_PICK_ANSWER pattern used for the interview experiment.
  const surveyGateEnabled = useGateValue('vi_jobseeker_survey_banner');
  const showSurveyBanner =
    import.meta.env.VITE_FORCE_SURVEY_BANNER === 'true' || surveyGateEnabled;
  const [processingButtons, setProcessingButtons] = useState<{[key: string]: boolean}>({
    register: false,
  });
  
  // const isInterviewComplete = sessionStorage.getItem('interviewComplete') === 'true';

  // Prevent back navigation
  useEffect(() => {

    // Disable the back button
    // window.history.pushState(null, '', window.location.pathname);
    // const handlePopState = () => {
    //   window.history.pushState(null, '', window.location.pathname);
    //   // Optional: Show a message that going back isn't allowed
    //   alert("You've already submitted your interview. Please close this tab.");
    // };
    // window.addEventListener('popstate', handlePopState);
    // return () => {
    //   window.removeEventListener('popstate', handlePopState);
    // };
  }, []);

  // load hotjar tracking onMount AS-3104
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:6389465,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    document.head.appendChild(script);
    
    // Cleanup on unmount
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  

  const hasPushedStage = useRef(false);
  useEffect(() => {
    if (!hasPushedStage.current) {
      hasPushedStage.current = true;
      const questionnaires = getWithExpiry('questionnaires');
      pushScreenerStage({
        stage_name: 'screener_completed',
        job_id: getWithExpiry('jobId') || '',
        applicant_guid: getWithExpiry('applicantGuid') || '',
        screener_question_count: Array.isArray(questionnaires) ? questionnaires.length : 0,
      });
    }
  }, []);

  const handleClose = () => {
    navigate('/v1/interview');
  };
  
  const handleRegister = async () => {
    await new Promise(resolve => setTimeout(resolve, 250));
    window.open(config.JOBSEEKER_API_URL, '_blank');
  };

  const handleButtonClick = (button: string, onClick: () => void) => {
    setProcessingButtons(prev => ({ ...prev, [button]: true }));
    onClick();
    setProcessingButtons(prev => ({ ...prev, [button]: false }));
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        // With the banner, flow content from the top (Figma "Approved Design");
        // without it, keep the original vertically-centered success screen.
        justifyContent: showSurveyBanner ? 'flex-start' : 'center',
        padding: '2rem',
        minHeight: 'calc(100vh - 250px)',
      }}
    >
      {/* VI-710: survey banner pinned to the top of the page (above the success
          graphic), matching the Figma "Approved Design". Only rendered when the
          Statsig gate is on. */}
      {showSurveyBanner && <SurveyBanner />}

      {/* Success block: horizontally centered, spacing set explicitly to match Figma. */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          width: '100%',
        }}
      >
        <img
          src="/svgs/done.svg"
          alt="Success"
          style={{
            marginBottom: '2rem',
          }}
        />
        <h2
          style={{
            margin: 0,
            fontWeight: 500,
            fontSize: '1.2rem',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}
        >
          Interview Successfully Completed
        </h2>
        <p style={{ margin: '0.5rem 0 0', fontSize: '0.9rem', color: '#6c757d' }}>Thank you for completing the interview</p>
        {/* Extra gap below the subtitle before the CTA (Figma ~64px). */}
        <div style={{ marginTop: '4rem', display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <Button showSpinner={processingButtons.register} text="Sign up as a Job Seeker" variant="outline-primary" onClick={() => handleButtonClick('register', handleRegister)} id="btn-registerasjobseeker-click" />
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
